var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconEdit = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "black",
    d: "M14.1047 4.6875C14.4591 4.33313 14.6541 3.8625 14.6541 3.36187C14.6541 2.86125 14.4591 2.39062 14.1047 2.03625L12.6178 0.549375C12.2634 0.195 11.7928 0 11.2922 0C10.7916 0 10.3209 0.195 9.9675 0.548438L0 10.485V14.6241H4.13719L14.1047 4.6875ZM11.2922 1.875L12.78 3.36094L11.2894 4.84594L9.8025 3.36L11.2922 1.875ZM1.875 12.7491V11.2631L8.475 4.68375L9.96188 6.17062L3.36281 12.7491H1.875ZM0 16.4991H15V18.3741H0V16.4991Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconEdit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Icon_Edit.a7f747de.svg";
export { ForwardRef as ReactComponent };